import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";

import * as setupReducer from "containers/Setup/reducer";

import ChooseProcessLimitContainer from "containers/CreateWizard/Constraints/ChooseProcessLimit";

class BusinessProcessLimitContainer extends React.PureComponent {
  render() {
    const { selectedBlueprintId } = this.props;
    return <ChooseProcessLimitContainer {...this.props} blueprintId={selectedBlueprintId} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({});

const mapStateToProps = (state, ownProps) => {
  return {
    selectedBlueprintId: setupReducer.getBlueprintId(state, ownProps.id)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(BusinessProcessLimitContainer);
